import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/links")({
  component: lazyRouteComponent(() => import("./-pages/admin.links")),
  head: () => ({
    meta: [
      { title: "Short Links · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
